export const generateOrderPDF = (orderData, orderNumber, menuItems) => {
  if (!orderData) return;

  // Create PDF content
  const pdfContent = `
Order #${orderNumber}
Date: ${new Date().toLocaleDateString()}
Time: ${new Date().toLocaleTimeString()}

${orderData.order_summary}

Items:
${orderData.items?.map(item => 
  `${item.quantity}x ${menuItems[item.item]?.name || item.item} - $${item.price.toFixed(2)}
   ${item.customizations?.length ? `Customizations: ${item.customizations.join(', ')}` : ''}`
).join('\n')}

Total: $${orderData.total?.toFixed(2) || '0.00'}

${orderData.special_instructions ? `Special Instructions: ${orderData.special_instructions}` : ''}

---
Generated by VoiceFlow AI Drive-Thru System
  `;

  // Create and download text file (simplified version)
  const blob = new Blob([pdfContent], { type: 'text/plain' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `order_${orderNumber}_${new Date().toISOString().split('T')[0]}.txt`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}; 